import styled from "styled-components";

export const colors = {
  pdf: "#0d9f00",
  image: "#d153dd",
  timelineEvent: "#2d8fd5",
  year: "#df5f6a",
};
const types = { pdf: "PDF", image: "" };

export const CardWrapper = styled.ul`
  --cardWidth: 200px;
  --cardHeight: 200px;
  padding: 0 0 0 var(--outerMargin);
  box-sizing: border-box;
  list-style-type: none;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  & > li {
    width: var(--cardWidth);
    min-height: var(--cardHeight);
    list-style-type: none;
    display: block;
    margin: 0 var(--gap) var(--gap) 0;
    padding: var(--gap);
    border-radius: 4px;
  }
`;

export const YearCard = styled.li`
  --accentColor: ${colors.year};
  background-color: var(--accentColor);
  color: var(--black);
  display: flex !important;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 48px;
  border: 1px solid var(--text);
`;

export const DateCard = styled.li`
  --accentColor: ${(props) =>
    props.objectType
      ? colors[props.objectType] || "var(--linkColor)"
      : "var(--linkColor)"};
  --type: ${(props) =>
    props.objectType ? `"${types[props.objectType] || ""}"` : `""`};
  position: relative;
  /* border: 1px solid var(--accentColor); */
  background-color: var(--white);
  color: var(--black);
  border: 1px solid var(--accentColor);
  & h2 {
    margin: calc(0px - var(--gap)) calc(0px - var(--gap)) 8px
      calc(0px - var(--gap));
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: var(--gap);
    font-size: 18px;
    line-height: 24px;
    color: var(--accentColor);
    font-weight: normal;
    & a {
      color: var(--accentColor);
    }
  }
  & p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }
  &:after {
    content: var(--type);
    position: absolute;
    bottom: var(--gap);
    right: var(--gap);
    color: var(--accentColor);
  }
`;

export const FilterNav = styled.nav`
  margin: var(--outerMargin);
  display: flex;
  align-items: center;
  & input {
    box-sizing: border-box;
    color: var(--linkColor);
    margin-left: 8px;
    height: 30px;
    border-radius: 0;
    border-color: transparent;
    outline: none;
    appearance: none;
    border: 1px solid var(--linkColor);
    padding: 4px 8px;
    font-family: var(--bodyFont);
    font-size: 16px;
  }
`;
